// @flow
import { exists, get } from '@zapier/common-utils';
import { type Service } from '../types';

export default function getServiceName(service: Service = {}) {
  if (service.name) {
    return service.name;
  }

  if (service.title) {
    return service.title;
  }

  if (exists(service.meta, ['human_readable_key'])) {
    return get(service.meta, ['human_readable_key']);
  }

  return service.key || 'Unnamed service';
}
